var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "result-bar",
      class: {
        "result-bar--open": _vm.showSearchWidget,
        "result-bar--notification": _vm.notification
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "result-bar__search",
          on: {
            click: function($event) {
              _vm.showSearchWidget = !_vm.showSearchWidget
            }
          }
        },
        [
          _c(
            "svg",
            {
              staticClass: "result-bar__search__icon",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 32.01 32.01"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M19.93,17.44a11,11,0,1,0-2.49,2.49L28,32l4-4ZM11,19a8,8,0,1,1,8-8A8,8,0,0,1,11,19Z"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "result-bar__search__text" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.destination.name) + ", " + _vm._s(_vm.dates))
            ]),
            _vm._v(" "),
            _c("span", {
              domProps: { textContent: _vm._s(_vm.numberOfTravelers) }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _vm.showSearchWidget
        ? _c(
            "div",
            { staticClass: "search-component" },
            [
              _c("search-widget", {
                ref: "searchwidget",
                attrs: { showFlexibleDateInfoBox: _vm.showFlexInfo },
                on: {
                  hideflexibleinfo: function($event) {
                    _vm.showFlexInfo = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("search-sort"),
      _vm._v(" "),
      _c("offer-counter")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-994e0b8c", { render: render, staticRenderFns: staticRenderFns })
  }
}